import React from "react"
import { createPortal } from "react-dom"
import { useEscapeKey, useOverlayClick } from "../../hooks"

const Modal = ({ title, onClose, children, footer, className }) => {
  useEscapeKey(onClose)
  const handleOverlayClick = useOverlayClick(onClose)

  return createPortal(
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className={className ? `modal ${className}` : "modal"}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close-btn" onClick={onClose} title="Close">
            ×
          </button>
        </div>
        <div className="modal-content">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  )
}

export default Modal
